import React from 'react';
import { FaFacebookF, FaInstagram, FaEnvelope } from 'react-icons/fa';
import { Link } from 'react-router-dom'; // for navigation to Impressum page

const AnnourFooter = () => {
  return (
    <footer className="bg-main text-white mt-20">
      <div className="text-center max-w-7xl mx-auto px-6 py-12 grid md:grid-cols-3 gap-8">
        {/* About */}
        <div>
          <h3 className="text-xl font-semibold mb-4">Annour e.V.</h3>
          <p className="text-sm">
            Arabische Schule in Braunschweig – Bildung, Kultur und
            Zusammenhalt für die nächste Generation.
          </p>
        </div>

        {/* Contact */}
        <div>
          <h3 className="text-xl font-semibold mb-4">Kontakt</h3>
          <ul className="text-sm space-y-2">
            <li>Email: verwaltung@annour-bs.de</li>
            <li>
              Unterrichtsaktivitätsort: Varrentrappstraße 21
              <br />
              38114 Braunschweig
              <br />
              Deutschland
            </li>
            <li>
              📍 Vereinssitz: Petzvalstr. 50
              <br />
              38104 Braunschweig
              <br />
              Deutschland
            </li>
            <li>Telefon: +49 152 594 315 15</li>
          </ul>
        </div>

        {/* Socials */}
        {/*<div>
          <h3 className="text-xl font-semibold mb-4">Folge uns</h3>
          <div className="flex space-x-4 text-lg">
            <a
              href="#"
              className="hover:text-accent transition-colors duration-200"
            >
              <FaFacebookF />
            </a>
            <a
              href="#"
              className="hover:text-accent transition-colors duration-200"
            >
              <FaInstagram />
            </a>
            <a
              href="mailto:info@annour-schule.de"
              className="hover:text-accent transition-colors duration-200"
            >
              <FaEnvelope />
            </a>
          </div>
        </div>

        {/* Legal / Impressum */}
        <div>
          <h3 className="text-xl font-semibold mb-4">Rechtliches</h3>
          <ul className="text-sm space-y-2">
            <li>
              <Link
                to="/impressum"
                className="hover:text-accent transition-colors duration-200"
              >
                Impressum
              </Link>
            </li>
            <li>
              <Link
                to="/datenschutz"
                className="hover:text-accent transition-colors duration-200"
              >
                Datenschutz
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="text-center text-sm border-t border-white/20 py-4">
        © {new Date().getFullYear()} Annour e.V. – Alle Rechte
        vorbehalten.
      </div>
    </footer>
  );
};

export default AnnourFooter;
